<template>
  <v-container grid-list-xs>
    <v-row>
      <v-col cols="12" md="4" lg="4" sm="6" :offset-md="item.offsetMd || 0" v-for="(item, i) in items" :key="i">
        <v-card class="ml-2">
          <div class="d-flex align-center">
            <div style="flex: 1; min-width: 0">
              <v-card-title class="headline">{{ item.title }}</v-card-title>
              <v-card-subtitle style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{ item.subTitle }}</v-card-subtitle>
            </div>

            <div class="d-flex align-center mx-4" style="flex-shrink: 0; min-width: 0">
              <v-divider vertical inset class="mr-4"></v-divider>
              <v-icon
                :color="item.color ? item.color : ''"
                size="30"
                v-if="item.icon"
                class="mr-2"
              >{{ item.icon }}</v-icon>
              <h2 :style="'white-space: nowrap; text-align: right; ' + (item.valueStyle || '')">
                {{ item.value }}
              </h2>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import http from "@/services/http";
import campanhas from "@/services/http/campanhaService";
import currencyMixin from "@/mixins/currencyMixin";
import dobrouGmr from "@/utils/dobrouGmr";
import multiplicadorBonus from "@/utils/multiplicadorBonus";

export default {
  name: "SectionCardsResumo",

  mixins: [currencyMixin],

  props: {
    // Fornecido pelo DetalhesCampanha para evitar refetch do endpoint de apuração.
    itemsApuracao: { type: Array, default: null }
  },

  data() {
    return {
      apuracaoItems: [],
      metasFlat: []
    };
  },

  computed: {
    ...mapGetters({
      getCampanha: "campanha/getCampanha"
    }),

    periodoLabel() {
      const fmt = d => {
        if (!d) return "—";
        const [date] = d.split(" ");
        const [y, m, day] = date.split("-");
        return `${day}/${m}/${y}`;
      };
      const c = this.getCampanha;
      if (!c.data_inicio && !c.data_final) return "—";
      return `${fmt(c.data_inicio)} - ${fmt(c.data_final)}`;
    },

    qtEmpresas() {
      return new Set(this.apuracaoItems.map(r => r.id_empresa).filter(Boolean)).size;
    },

    totalBonusPago() {
      return this.apuracaoItems
        .filter(r => r.ganhou_meta === "S" || r.ganhou_meta === true)
        .reduce((sum, r) => sum + (parseFloat(r.valor_bonus_pagamento) || 0), 0);
    },

    metaInfoMap() {
      const map = {};
      for (const row of this.metasFlat) {
        const id = row.id_campanha_meta;
        if (!id) continue;
        if (!map[id]) {
          map[id] = {
            colaboradores: [],
            indicadores: [], indicadoresRaw: [], faixasIndicador: [],
            chassi: [],
            modelos: [], modelosRaw: [], faixasModelo: [],
            pecas: [], pecasRaw: [], faixasPeca: [],
            servicos: [], servicosRaw: [], faixasServico: []
          };
        }
        const m = map[id];
        if (row.colaborador && !m.colaboradores.some(c => c.nome === row.colaborador))
          m.colaboradores.push({ nome: row.colaborador });
        if (row.id_tipo_conteudo == 1 && row.id_tipo_calculo != 2 && row.id_indicador) {
          if (!m.indicadores.some(i => i.id_indicador == row.id_indicador))
            m.indicadores.push({ id_indicador: row.id_indicador, valor_meta: row.valor_meta, valor_bonus: row.valor_bonus , base_calculo_indicador: row.base_calculo_indicador || null, tipo_apuracao: row.tipo_apuracao || null });
          if (row.colaborador) {
            const rk = `${row.colaborador}-${row.id_indicador}`;
            if (!m.indicadoresRaw.some(r => r._key === rk))
              m.indicadoresRaw.push({ _key: rk, colaborador: row.colaborador, id_indicador: row.id_indicador, valor_meta: row.valor_meta, valor_bonus: row.valor_bonus , base_calculo_indicador: row.base_calculo_indicador || null, tipo_apuracao: row.tipo_apuracao || null });
          }
        }
        if (row.id_tipo_conteudo == 1 && row.id_tipo_calculo == 2 && row.id_indicador && row.qtde_de != null) {
          const key = `${row.id_indicador}-${row.qtde_de}-${row.qtde_ate}`;
          if (!m.faixasIndicador.some(f => f._key === key))
            m.faixasIndicador.push({ _key: key, id_indicador: row.id_indicador, qtde_de: row.qtde_de, qtde_ate: row.qtde_ate, valor_bonus: row.valor_bonus , base_calculo_indicador: row.base_calculo_indicador || null, tipo_apuracao: row.tipo_apuracao || null });
        }
        if (row.id_tipo_conteudo == 2 && row.chassi_completo) {
          if (!m.chassi.some(c => c.chassi_completo === row.chassi_completo))
            m.chassi.push({ chassi_completo: row.chassi_completo, valor_bonus: row.valor_bonus });
        }
        if (row.id_tipo_conteudo == 3 && row.id_tipo_calculo != 2 && row.id_produto) {
          if (!m.modelos.some(p => p.id_produto == row.id_produto))
            m.modelos.push({ id_produto: row.id_produto, valor_meta: row.valor_meta, valor_bonus: row.valor_bonus });
          if (row.colaborador) {
            const rk = `${row.colaborador}-${row.id_produto}`;
            if (!m.modelosRaw.some(r => r._key === rk))
              m.modelosRaw.push({ _key: rk, colaborador: row.colaborador, id_produto: row.id_produto, valor_meta: row.valor_meta, valor_bonus: row.valor_bonus });
          }
        }
        if (row.id_tipo_conteudo == 3 && row.id_tipo_calculo == 2 && row.id_produto && row.qtde_de != null) {
          const key = `${row.id_produto}-${row.qtde_de}-${row.qtde_ate}`;
          if (!m.faixasModelo.some(f => f._key === key))
            m.faixasModelo.push({ _key: key, id_produto: row.id_produto, qtde_de: row.qtde_de, qtde_ate: row.qtde_ate, valor_bonus: row.valor_bonus });
        }
        if (row.id_tipo_conteudo == 4 && row.id_tipo_calculo != 2 && row.id_peca) {
          if (!m.pecas.some(p => p.id_peca == row.id_peca))
            m.pecas.push({ id_peca: row.id_peca, valor_meta: row.valor_meta, valor_bonus: row.valor_bonus });
          if (row.colaborador) {
            const rk = `${row.colaborador}-${row.id_peca}`;
            if (!m.pecasRaw.some(r => r._key === rk))
              m.pecasRaw.push({ _key: rk, colaborador: row.colaborador, id_peca: row.id_peca, valor_meta: row.valor_meta, valor_bonus: row.valor_bonus });
          }
        }
        if (row.id_tipo_conteudo == 4 && row.id_tipo_calculo == 2 && row.id_peca && row.qtde_de != null) {
          const key = `${row.id_peca}-${row.qtde_de}-${row.qtde_ate}`;
          if (!m.faixasPeca.some(f => f._key === key))
            m.faixasPeca.push({ _key: key, id_peca: row.id_peca, qtde_de: row.qtde_de, qtde_ate: row.qtde_ate, valor_bonus: row.valor_bonus });
        }
        if (row.id_tipo_conteudo == 5 && row.id_tipo_calculo != 2 && row.id_servico) {
          if (!m.servicos.some(p => p.id_servico == row.id_servico))
            m.servicos.push({ id_servico: row.id_servico, valor_meta: row.valor_meta, valor_bonus: row.valor_bonus });
          if (row.colaborador) {
            const rk = `${row.colaborador}-${row.id_servico}`;
            if (!m.servicosRaw.some(r => r._key === rk))
              m.servicosRaw.push({ _key: rk, colaborador: row.colaborador, id_servico: row.id_servico, valor_meta: row.valor_meta, valor_bonus: row.valor_bonus });
          }
        }
        if (row.id_tipo_conteudo == 5 && row.id_tipo_calculo == 2 && row.id_servico && row.qtde_de != null) {
          const key = `${row.id_servico}-${row.qtde_de}-${row.qtde_ate}`;
          if (!m.faixasServico.some(f => f._key === key))
            m.faixasServico.push({ _key: key, id_servico: row.id_servico, qtde_de: row.qtde_de, qtde_ate: row.qtde_ate, valor_bonus: row.valor_bonus });
        }
      }
      return map;
    },

    totalCustoEstimado() {
      let total = 0;
      const seen = new Set();
      for (const row of this.metasFlat) {
        const id = row.id_campanha_meta;
        if (!id || seen.has(id)) continue;
        seen.add(id);
        total += this.calcularCustoMeta(row, this.metaInfoMap[id] || {});
      }
      return total;
    },

    colabGanharam() {
      return new Set(
        this.apuracaoItems
          .filter(r => r.ganhou_meta === "S" || r.ganhou_meta === true)
          .map(r => r.id_colaborador)
          .filter(Boolean)
      );
    },

    qtBateramMeta() {
      return this.colabGanharam.size;
    },

    qtNaoBateramMeta() {
      const todos = new Set(this.apuracaoItems.map(r => r.id_colaborador).filter(Boolean));
      return [...todos].filter(id => !this.colabGanharam.has(id)).length;
    },

    qtRealizado() {
      const total = this.apuracaoItems.reduce(
        (s, r) => s + (parseFloat(r.valor_realizado) || 0),
        0
      );
      return Number.isInteger(total)
        ? total.toLocaleString("pt-BR")
        : total.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    qtParticipantes() {
      return new Set(this.apuracaoItems.map(r => r.id_colaborador).filter(Boolean)).size;
    },

    taxaAdesao() {
      if (!this.qtParticipantes) return "0%";
      return `${Math.round((this.qtBateramMeta / this.qtParticipantes) * 100)}%`;
    },

    gmrInfo() {
      const row = this.apuracaoItems.find(r => r.valor_meta_gmr != null);
      if (!row) return null;
      return {
        superou: row.superou_gmr === "S" || row.superou_gmr === true,
        crescimento: row.crescimento_gmr,
        percentualEstimado: row.percentual_gmr,
        percentualDobro: row.percentual_dobro
      };
    },

    items() {
      const cards = [
        {
          title: "Empresas",
          subTitle: "Participantes",
          value: this.qtEmpresas,
          color: "primary",
          icon: "mdi-domain"
        },
        {
          title: "Custo",
          subTitle: "Estimado",
          value: currencyMixin.filters.BrazilianCurrency(this.totalCustoEstimado),
          color: "primary",
          icon: "mdi-cash"
        },
        {
          title: "Bônus Pago",
          subTitle: "Total",
          value: currencyMixin.filters.BrazilianCurrency(this.totalBonusPago),
          color: "primary",
          icon: "mdi-cash-check"
        },
        {
          title: "Crescimento",
          subTitle: "Estimado",
          value: `${this.gmrInfo?.percentualEstimado ?? 0}%`,
          color: "primary",
          icon: "mdi-percent"
        },
        {
          title: "Crescimento",
          subTitle: "Dobro",
          value: `${this.gmrInfo?.percentualDobro ?? 0}%`,
          color: "primary",
          icon: "mdi-percent"
        },
        ...(this.gmrInfo
          ? [
              {
                title: "GMR",
                subTitle: !this.gmrInfo.superou
                  ? "Não Atingido"
                  : dobrouGmr(this.gmrInfo.crescimento, this.gmrInfo.percentualDobro)
                    ? "Atingido (Bônus ×2)"
                    : "Atingido (Bônus Liberado)",
                value: `${this.gmrInfo.crescimento || 0}%`,
                color: this.gmrInfo.superou ? "success" : "grey",
                icon: "mdi-chevron-double-up"
              }
            ]
          : []),
        {
          title: "Participantes",
          subTitle: "Total",
          value: new Set(this.apuracaoItems.map(r => r.id_colaborador).filter(Boolean)).size,
          color: "success",
          icon: "mdi-arrow-up"
        },
        {
          title: "Bateram a Meta",
          subTitle: "Participantes",
          value: this.qtBateramMeta,
          color: "success",
          icon: "mdi-arrow-up"
        },
        {
          title: "Não Bateram",
          subTitle: "Participantes",
          value: this.qtNaoBateramMeta,
          color: "error",
          icon: "mdi-arrow-down"
        },
        {
          title: "Adesão",
          subTitle: `${this.qtBateramMeta} de ${this.qtParticipantes}`,
          value: this.taxaAdesao,
          color: "success",
          icon: "mdi-account-check"
        },
        {
          title: "Realizado",
          subTitle: "Total",
          value: this.qtRealizado,
          color: "primary",
          icon: "mdi-counter"
        }
      ];
      // Período sempre à direita da última linha: offset dinâmico conforme o nº
      // de cards (o GMR entra/sai), pra não cair sozinho numa linha de baixo.
      cards.push({
        title: "Período",
        subTitle: "Início - Fim",
        value: this.periodoLabel,
        color: "primary",
        icon: "mdi-calendar-range",
        valueStyle: "font-size: 1.05rem",
        offsetMd: (2 - (cards.length % 3)) * 4
      });
      return cards;
    }
  },

  methods: {
    async carregar() {
      try {
        const idCampanha = this.$router.history.current.params.idCampanha;
        const { data } = await http.get("/campanhas/apuracao-campanha", {
          params: { id_campanha: idCampanha, per_page: -1 }
        });
        this.apuracaoItems = Array.isArray(data) ? data : data.data || [];
      } catch {
        this.apuracaoItems = [];
      }
    },

    async carregarMetas() {
      try {
        const idCampanha = this.$router.history.current.params.idCampanha;
        const res = await campanhas().metasCampanha().show({ id_campanha: idCampanha, per_page: -1 });
        this.metasFlat = Array.isArray(res?.data) ? res.data : res?.data?.data || [];
      } catch {
        this.metasFlat = [];
      }
    },

    calcularCustoMeta(row, info) {
      const tipoPagamento = Number(row.id_tipo_pagamento);
      const tipoCalculo = Number(row.id_tipo_calculo);
      const tipoConteudo = Number(row.id_tipo_conteudo);
      const nColaboradores = (info.colaboradores || []).length || 1;

      // Faixa progressiva — usa maior faixa como estimativa
      if (tipoCalculo === 2) {
        const faixasMap = {
          1: { faixas: info.faixasIndicador || [], idKey: 'id_indicador' },
          3: { faixas: info.faixasModelo    || [], idKey: 'id_produto' },
          4: { faixas: info.faixasPeca      || [], idKey: 'id_peca' },
          5: { faixas: info.faixasServico   || [], idKey: 'id_servico' }
        }[tipoConteudo];
        if (!faixasMap) return 0;
        const ids = [...new Set(faixasMap.faixas.map(f => f[faixasMap.idKey]))];
        let por = 0;
        ids.forEach(id => {
          const faixas = faixasMap.faixas.filter(f => f[faixasMap.idKey] == id).sort((a, b) => parseFloat(b.qtde_ate) - parseFloat(a.qtde_ate));
          if (faixas.length)
            por +=
              multiplicadorBonus({
                tipoPagamento,
                tipoApuracao: faixas[0].tipo_apuracao,
                baseCalculo: faixas[0].base_calculo_indicador,
                quantidade: faixas[0].qtde_ate
              }) * (parseFloat(faixas[0].valor_bonus) || 0);
        });
        return por * nColaboradores;
      }

      if (tipoConteudo === 2) {
        return (info.chassi || []).reduce((sum, c) => sum + (parseFloat(c.valor_bonus) || 0), 0);
      }

      if (tipoConteudo === 1) {
        const bonus = parseFloat(row.valor_bonus) || 0;
        if (tipoPagamento !== 1) return bonus * nColaboradores;
        // Por unidade: usa raw por colaborador para tratar metas individuais com
        // alvos distintos. O multiplicador e por INDICADOR - margem 'P' entra
        // com zero, quantidade com a meta.
        const mult = r =>
          multiplicadorBonus({
            tipoPagamento,
            tipoApuracao: r.tipo_apuracao,
            baseCalculo: r.base_calculo_indicador,
            quantidade: r.valor_meta
          });
        const rawRows = info.indicadoresRaw || [];
        if (rawRows.length > 0) {
          const colabs = [...new Set(rawRows.map(r => r.colaborador))];
          let total = 0;
          colabs.forEach(colab => {
            const rows = rawRows.filter(r => r.colaborador === colab);
            total += rows.reduce((s, r) => s + mult(r), 0) * bonus;
          });
          return total;
        }
        return (
          (info.indicadores || []).reduce((sum, ind) => sum + mult(ind), 0) *
          bonus *
          nColaboradores
        );
      }

      // Tipos 3, 4, 5 (Modelo, Peça, Serviço): usa raw por colaborador×item
      const rawMap = { 3: info.modelosRaw, 4: info.pecasRaw, 5: info.servicosRaw };
      const rawRows = rawMap[tipoConteudo] || [];
      if (rawRows.length > 0) {
        return rawRows.reduce((s, r) => s + (tipoPagamento === 1
          ? (parseFloat(r.valor_meta) || 0) * (parseFloat(r.valor_bonus) || 0)
          : (parseFloat(r.valor_bonus) || 0)), 0);
      }
      // Fallback: listas deduplicadas × nColaboradores
      const listMap = { 3: info.modelos, 4: info.pecas, 5: info.servicos };
      let por = 0;
      (listMap[tipoConteudo] || []).forEach(item => {
        por += tipoPagamento === 1
          ? (parseFloat(item.valor_meta) || 0) * (parseFloat(item.valor_bonus) || 0)
          : (parseFloat(item.valor_bonus) || 0);
      });
      return por * nColaboradores;
    }
  },

  async mounted() {
    if (this.itemsApuracao) {
      this.apuracaoItems = this.itemsApuracao;
      await this.carregarMetas();
    } else {
      await Promise.all([this.carregar(), this.carregarMetas()]);
    }
  }
};
</script>

<style scoped>
.v-card {
  height: 100%;
}
</style>
